import { createCacheKey, ENDPOINTS, handleErrorResponse, useCreatePayload } from 'hammock';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { useDefaultVariants } from '@candu-ai/styleguide/application-variants';
import { BaseStylesheetRules } from 'craft/state/styleguide/types';
import { EditorStyleguide } from 'craft/types';

import { SET_EDITOR_STYLEGUIDE } from './constants';
import { createEditorStyleguide } from './createEditorStyleguide';

export const setEditorStyleguide = (styleguide: EditorStyleguide) => {
  return {
    type: SET_EDITOR_STYLEGUIDE,
    styleguide,
  };
};

const useBaseStylesheetRules = () => {
  const { get } = useCreatePayload(ENDPOINTS.styleguideProcessor);

  const payload = get({ id: 'base-stylesheet.json' });

  const cacheKey = createCacheKey(payload);
  const query = useQuery<BaseStylesheetRules[], Error>(cacheKey, async () => {
    try {
      return (await fetch(payload.endpoint).then((r) => r.json())) as BaseStylesheetRules[];
    } catch (e) {
      throw handleErrorResponse(e, payload);
    }
  });

  return {
    ...query,
    cacheKey,
  };
};

export const useLoadEditorStyleguide = () => {
  const baseStylesheetRules = useBaseStylesheetRules();
  const defaultStyleguide = useDefaultVariants();
  const dispatch = useDispatch();

  if (baseStylesheetRules.status !== 'success' || defaultStyleguide.status !== 'success') {
    return;
  }

  dispatch(
    setEditorStyleguide(
      createEditorStyleguide(baseStylesheetRules.data, defaultStyleguide.data.variants),
    ),
  );
};
